import className from '../../common/className.js'
import ExportCSVButton from './ExportCSVButton.js'
import HorizontalBarGraph from './HorizontalBarGraph.js'

/**
 * Horizontal bar pane
 *
 * @param {Object} props
 * @param {Boolean} props.isLoading
 * @param {String} props.title
 * @param {Object} props.data
 * @param {Boolean} props.isCurrency
 * @param {Function} props.onExport
 * @returns {React.ReactNode}
 */
export default function HorizontalBarPane({
  isLoading,
  title,
  data,
  isCurrency,
  onExport,
}) {
  return (
    <div
      className={className`panel panel--analytics clearfix ${{
        loading: isLoading,
      }}`}
    >
      <div className="panel__header panel__header--analytics flex--justify">
        <h3 className="subheader subheader--analytics">{title}</h3>
        {onExport && data && <ExportCSVButton onExport={onExport} />}
      </div>
      <div className="medium-12 columns">
        <HorizontalBarGraph data={data} isCurrency={isCurrency} />
      </div>
    </div>
  )
}
